import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { Loader } from '@/components/common/Loader';
import { useTranslations } from '@/core/translations';
import { useAssetDecisions } from '@/components/pages/SituationalAwareness/hooks/useAssetDecisions';
import { getIncidentTagColor } from '@/components/pages/SituationalAwareness/components/utils/getIncidentTagColor';
import { DecisionItem } from './components/DecisionItem';

export const TargetAssetDecisions: React.FC<{ assetId: string }> = ({ assetId }) => {
  const t = useTranslations('incidents_page.assets_card');
  const { data: decisions, isFetching, isFetched } = useAssetDecisions({ assetId });
  const noDecisionsAvailable = isFetched && isEmpty(decisions);
  const tagColorSchema: Record<string, React.CSSProperties> = useMemo(() => {
    const uniqueTags = [...new Set(decisions?.flatMap((item) => item.Tags) ?? [])];

    return uniqueTags.reduce(
      (acc, tag, index) => {
        acc[tag] = { background: getIncidentTagColor(index) };
        return acc;
      },
      {} as Record<string, React.CSSProperties>,
    );
  }, [decisions]);

  return (
    <div className="flex h-full flex-col items-center">
      {isFetching && <Loader />}
      {noDecisionsAvailable && <p className="p-[24px]">{t('no_decisions')}</p>}
      {decisions?.map((decision) => (
        <DecisionItem decision={decision} key={decision.DecisionID} tagColorSchema={tagColorSchema} />
      ))}
    </div>
  );
};
